<template>
  <div class="msg-wrapper">
    <co-button
      ref="replyBtn"
      @click="replyCon"
    >
      {{ $t('留言') }}
    </co-button>
    <!-- <div class="l-btn lv-80 msg c-btn" ref="replyBtn" @click="replyCon">{{$t('留言')}}</div> -->
    <div
      v-show="isShow"
      ref="replyMain"
      :class="['wrapper', lang =='en'? 'wrapper-en':'']"
      :style="replyPos"
    >
      <span class="i-close">
        <svg
          class="close-svg"
          @click="close"
        >
          <use xlink:href="#close" />
        </svg>
      </span>

      <div class="ly-title">
        {{ $t('留言') }}
      </div>
      <div class="reply-wrapper">
        <div class="receiver">
          <div class="title receiver-title">
            {{ $t('收件人') }}:
          </div><!--
                    --><div class="receiver-name">
{{ receiverName() }}
</div>
        </div>
        <div class="sender">
          <div class="title sender-title">
            {{ $t('发件人') }}:
          </div><!--
                    --><div
v-if="!hasSender"
class="sender-section"
>
                        <input
v-model="emailNum"
type="text"
:class="['sender-email', emailErr? 'error-border':'']"
:placeholder="$t('请输入邮箱')"
@input="emailErr=''"
@blur="verifyEmail"
>
                        <div :class="['warn', emailErr? '':'padding-included']">
{{ $t(emailErr) }}
</div>
                        <div class="captcha">
                            <input
v-model="captchaNum"
type="text"
:class="['captcha-input', captchaErr? 'error-border':'']"
:placeholder="$t('请输入右侧的验证码')"
@input="captchaErr=''"
><!--
                            --><div
id="captchaPic"
class="captcha-pic"
/>
                        </div>
                        <div :class="['warn', captchaErr? '':'padding-included']">
{{ $t(captchaErr) }}
</div>
          </div><!--
                    --><div
v-else
class="sender-name"
>
                        <span class="email-name">{{ this.senderEmail }}</span>
                        <div :class="['warn', emailErr? '':'padding-included']">
{{ $t(emailErr) }}
</div>
                    </div>
        </div>
        <div class="reply">
          <div class="title reply-title">
            {{ $t('内容') }}:
          </div><!--
                    --><textarea
v-model="replyContent"
maxlength="301"
:class="['reply-content', replyErr? 'error-border':'']"
:placeholder="$t('请输入回复内容，最多300个字')"
@input="replyHandler"
/>
          <div
            :class="['warn reply-warn', replyErr? '':'padding-included']"
            :style="{'text-align': replyExdMax? 'right':'left'}"
          >
            {{ $t(replyErr) }}
          </div>
        </div>
      </div>
      <co-button
        :self-class="getSendBtn"
        @click="sendReply"
      >
        {{ replyPending ? $t('发送中...') : $t('发送') }}
      </co-button>
    </div>
  </div>
</template>
<script>
import coButton from 'components/common/button/index.vue'
import { validEmail, getLanguage } from 'js/util/util.js'
import { GVerify } from 'js/api/gVerify.js'

const { postData } = require('js/api/getdata').default

export default {
  components: {
    coButton,
  },
  props: {
    /**
         * 外链相关和sm相关，在reply里主要用code和sm中的信息
         */
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShow: false, // 控制留言框
      emailNum: '', // 输入的邮箱地址
      senderEmail: '', // 固定的收件人邮箱
      captchaNum: '', // 输入的图形验证码
      replyContent: '', // 回复内容
      emailErr: '', // email错误提示
      captchaErr: '', // 图像验证码部分错误提示
      replyErr: '', // 回复部分错误提示
      replyExdMax: false, // 回复内容字数是否超限（300）
      verifyCode: null, // 图形验证码实例
      replyPos: {}, // 回复主题相对回复button的定位
      replyPending: false, // 回复-发送中
    }
  },
  computed: {
    lang() {
      return getLanguage()
    },
    shareInfo() {
      const shareInfo = { ...this.data.ext }
      shareInfo._id = this.data.deliverycode
      return shareInfo
    },
    /**
         * creator 收件人
         */
    creator() {
      if (this.shareInfo.linkInfo) {
        return this.shareInfo.linkInfo.user_name || ''
      }
    },
    /**
         * 是否有发件人
         */
    hasSender() {
      if (!this.shareInfo.emailOrMobile) return
      if (this.shareInfo.receiver_setting == 2 && this.shareInfo.emailOrMobile.indexOf('@') > -1) { // 只有勾选 邮箱/手机号 + 验证码时才有可能显示发件人邮箱
        this.senderEmail = this.shareInfo.emailOrMobile
        return true
      }
      return false
    },
    /**
         * 是否diabled发送button
         */
    isDisableBtn() {
      if (!this.hasSender && (!this.emailNum.length || !this.captchaNum.length)) {
        return true
      }
    },
    /**
         * sender button style for co-button
         */
    getSendBtn() {
      if (this.replyPending) {
        return 's-btn send-btn s-btn-disabled'
      }
      if (this.isDisableBtn) {
        return 's-btn send-btn s-btn-disabled'
      }
      return 's-btn send-btn'
    },
  },
  mounted() {
    if (!this.verifyCode) {
      this.verifyCode = new GVerify('captchaPic')
    } else {
      this.verifyCode.refresh()
    }
    this.calcPos() // 计算留言的位置
  },
  methods: {
    /**
         * 收件人email creator + email
         */
    receiverName() {
      return `${this.creator} ${this.shareInfo.createrEmail}`
    },
    /**
         * 验证图形验证码
         */
    verifyCaptcha() {
      if (this.verifyCode) {
        const res = this.verifyCode.validate(this.captchaNum)
        if (res) return false
        this.captchaErr = '验证码错误'
        return true
      }
    },
    /**
         * 检验email填写是否正确
         */
    verifyEmail() {
      if (!this.hasSender && !validEmail(this.emailNum.trim())) {
        this.emailErr = '请输入正确的邮箱格式'
        return true
      }
    },
    /**
         * 检查验证码是否为空
         */
    checkCaptchaEmp() {
      if (!this.hasSender) {
        if (!this.captchaNum.trim()) {
          this.captchaErr = '验证码不能为空'
          return true
        }
      }
    },
    /**
         * 检查回复内容是否为空
         */
    checkReplyEmp() {
      if (!this.replyContent) {
        this.replyErr = '请输入回复内容'
        return true
      }
    },
    /**
         * 检查回复的字符是否输入超过300
         */
    replyHandler() {
      if (this.replyErr) this.replyErr = '' // 清空错误提示
      if (this.replyContent.length > 300) {
        this.replyExdMax = true
        this.replyErr = '最多可输入300个字符'
      } else {
        this.replyExdMax = false
      }
    },
    /**
         * 重置所有信息
         */
    resetReplyInfo() {
      // reset
      [this.emailNum, this.captchaNum, this.replyContent] = ['', '', ''];
      [this.emailErr, this.captchaErr, this.replyErr] = ['', '', '']
      this.replyExdMax = false
      // refresh captcha
      if (!this.verifyCode) {
        this.verifyCode = new GVerify('captchaPic')
      } else {
        this.verifyCode.refresh()
      }
    },
    /**
         * 发送邮件
         */
    sendReply() {
      if (this.isDisableBtn) return
      if (this.verifyEmail()) return
      if (this.checkCaptchaEmp()) return
      if (this.verifyCaptcha()) return
      if (this.checkReplyEmp()) return
      if (this.replyExdMax) return // reply max 300
      if (this.replyPending) return // 发送中...，不重新发送
      const params = {
        sToken: this.shareInfo.sToken,
        bindId: this.shareInfo._id,
        mailInfo: this.replyContent.replace(/</g, '&lt;').replace(/>/g, '&gt;'),
        senderEmail: this.emailNum,
      }
      this.replyPending = true // 发送中
      postData('smReply', params).then((res) => {
        this.$toast.simpleShow('发送成功', 'success')
        this.resetReplyInfo()
        this.isShow = false
        this.replyPending = false
      }).catch((err) => {
        this.$toast.simpleShow('发送失败，请重新发送', 'error')
        this.replyPending = false
      })
    },
    /**
         * 控制留言框是否出现
         */
    replyCon() {
      this.isShow = !this.isShow
    },
    /**
         * close x 关闭留言
         */
    close() {
      this.resetReplyInfo()
      this.isShow = false
    },
    /**
         * 计算留言的定位
         */
    calcPos() {
      const REPLYWIDTH = this.$refs.replyMain.offsetWidth || 451 // reply的宽度
      // 留言button left
      const left = this.$refs.replyBtn && this.$refs.replyBtn.$el ? this.$refs.replyBtn.$el.getBoundingClientRect().left : document.body.clientWidth
      const space = document.body.clientWidth - left
      if (space <= REPLYWIDTH) {
        this.replyPos = {
          left: `-${REPLYWIDTH - space}px`,
        }
        return
      }
      this.replyPos = {
        left: '-8px', // 默认距离button水平8px
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
.msg-wrapper{
  position: relative;
  display: inline-block;
  .msg{
    cursor: pointer;
  }
}
.wrapper{
  position: absolute;
  top: 50px;
  width: 451px;
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #E7EAEE;
  box-shadow: 0 2px 12px 0 rgba(27,39,51,0.15);
  line-height: 20px;
  .i-close{
    float: right;
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
    color: #929ca9;
    cursor: pointer;
    .close-svg{
      width: 12px;
      height:12px;
    }
  }
}
.ly-title{
  font-size: 16px;
  color: #1B2733;
  margin-bottom: 21px;
}
.send-btn{
  float: right;
  cursor: pointer;
  margin: 0px;
}
.reply-wrapper{
  .title{
    display: inline-block;
    width: 56px;
    color: #637282;
    margin-right: 4px;
    vertical-align: top;
    line-height: 20px;
  }
  .warn{
    font-size: 14px;
    color: #ff3d3c;
    text-align: left;
    padding: 8px 0 0 0;
    height: 20px;
    max-width: 341px;
  }
  .padding-included{
    box-sizing: border-box;
  }
  .error-border{
    border: 1px solid #FF3D3C !important;
  }
  .receiver{
    font-size: 14px;
    margin: 0 0 20px 0;
    .receiver-name{
      display: inline-block;
      max-width: 341px;
      color: #1B2733;
      box-sizing: border-box;
      word-break: break-all;
    }
  }
  .sender{
    .sender-name{
      display: inline-block;
      max-width: 341px;
      color: #1B2733;
      box-sizing: border-box;
      .email-name{
        word-break: break-all;
      }
    }
    .sender-section {
      display: inline-block;
      .sender-email{
        height: 38px;
        line-height: 38px;
        width: 341px;
        padding: 0px 12px;
        border: 1px solid #C1C7CD;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
      }
      .captcha{
        .captcha-input{
          height: 38px;
          line-height: 38px;
          width: 251px;
          padding: 0px 12px;
          border: 1px solid #C1C7CD;
          border-radius: 2px;
          outline: none;
          box-sizing: border-box;
        }
        .captcha-pic{
          height: 38px;
          line-height: 38px;
          width: 90px;
          display: inline-block;
          box-sizing: border-box;
          vertical-align: top;
        }
      }
    }
  }
  .reply{
    .reply-content{
      height: 82px;
      width: 341px;
      padding: 10px 12px;
      border: 1px solid #C1C7CD;
      border-radius: 2px;
      outline: none;
      resize: none;
      box-sizing: border-box;
    }
    .reply-warn{
      padding: 4px 0 0 60px; // 60=56+4(title的宽+间距)
    }
  }
}
.wrapper::after{
  display: block;
  content:'';
  clear: both;
}
// 英语加，加宽wrapper
.wrapper-en{
  width: 465px;
  .title {
    width: 70px;
  }
}
</style>
